import { render, staticRenderFns } from "./_maincolumns.vue?vue&type=template&id=43de8a64&scoped=true&"
import script from "./_maincolumns.vue?vue&type=script&lang=ts&"
export * from "./_maincolumns.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43de8a64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43de8a64')) {
      api.createRecord('43de8a64', component.options)
    } else {
      api.reload('43de8a64', component.options)
    }
    module.hot.accept("./_maincolumns.vue?vue&type=template&id=43de8a64&scoped=true&", function () {
      api.rerender('43de8a64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_showcase/templates/_maincolumns.vue"
export default component.exports